export default "__VITE_ASSET__Bp2nY4PQ__"